module.exports = import("https://js.stripe.com/v3/pricing-table.js");;